import { Grid, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import React from 'react'
import { formatDate } from '../../../../common/formatDate';
import { TravelerModal } from '../../../../common/travelerModal';
import { useDefaultColumn } from '../../../../../util/filter';
import { useFilters, useGlobalFilter, useSortBy, useTable } from 'react-table';
import MuiTable from "@material-ui/core/Table";

export const EolUnitsTable = ({ tableData }: any) => {


    const defaultColumn = useDefaultColumn();

    const columns :any = React.useMemo(
        () => [
            {
                Header: "Id",
                accessor: "id",
            },
            {
                Header: "Serial Number",
                accessor: "serial_number",
                Cell: ({ cell }: any) => {
                    return <TravelerModal serialNumber={cell.value} />;
                },
            },
            {
                Header: "Unit Disposition",
                accessor: "unit_disposition",
                Cell: ({ row }: any) => {
                    return (
                        <div>
                            {row.original.unit_disposition ? row.original.unit_disposition : "N/A"}
                        </div>
                    );
                }
            },
            {
                Header: "Project Weight",
                accessor: "project_weight",
                Cell: ({ row }: any) => {
                    return (
                        <div>
                            {row.original.project_weight ? row.original.project_weight : "N/A"}
                        </div>
                    );
                }
            },
            {
                Header: "Test Sequence Definition Name",
                accessor: "test_sequence_definition_name",
                Cell: ({ row }: any) => {
                    return (
                        <div>
                            {row.original.test_sequence_definition_name ? row.original.test_sequence_definition_name : "N/A"}
                        </div>
                    );
                }
            },
            
            
            
            {
                Header: "Completion  Date",
                accessor: "completion_date",
                Cell: ({ cell }: any) => {
                    if (cell.value !== null && cell.value !== undefined) {
                        return (
                            <Typography variant="body2">
                                {" "}
                                {formatDate(cell.value)}{" "}
                            </Typography>
                        );
                    } else {
                        return "N/A";
                    }
                },
            },
            {
                Header: "Linear Execution Group",
                accessor: "linear_execution_group",
                Cell: ({ row }: any) => {
                    return (
                        <div>
                            {row.original.linear_execution_group ? row.original.linear_execution_group : "N/A"}
                        </div>
                    );
                }
            },
        ],
        []
    );

    const { getTableProps, headerGroups, rows, prepareRow } = useTable(
        {
            data: tableData,
            columns,
            defaultColumn,
            initialState: {
                hiddenColumns: ["id", "project_weight"],
            },
        },

        useFilters,
        useGlobalFilter,
        useSortBy
    );
    return (
        <>
            <TableContainer data-testid="tableContainer">
                <MuiTable {...getTableProps()} size="small">
                    <TableHead style={{ backgroundColor: "#e6e6e6" }}>
                        {headerGroups.map((headerGroup) => (
                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <TableCell>
                                        <Grid
                                            container
                                            direction="row"
                                            /*justify="space-between"*/
                                            alignItems="center"
                                            spacing={0}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                {...column.getHeaderProps(
                                                    column.getSortByToggleProps()
                                                )}
                                            >
                                                <Typography variant="subtitle1">
                                                    {column.render("Header")}
                                                    {column.isSorted
                                                        ? column.isSortedDesc
                                                            ? " 🔽"
                                                            : " 🔼"
                                                        : ""}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            prepareRow(row);
                            return (
                                <TableRow {...row.getRowProps()}>
                                    {row.cells.map((cell) => {
                                        return (
                                            <TableCell {...cell.getCellProps()}>
                                                {cell.render("Cell")}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </MuiTable>
            </TableContainer>

        </>
    )
}


